/// <reference types="vite/client" />

import i18nLibrary from 'i18next';
import ReactPostprocessor from 'i18next-react-postprocessor';
import HttpApi from 'i18next-http-backend';

import { initReactI18next } from 'react-i18next';
import { getNodeEnv } from '@shared/utils/getEnvironmentVariables';
import { getInitOptions } from './utils';
import { manifest } from '@locales/generated';

const { isDevelopment } = getNodeEnv();

const getHost = () => {
  if (isDevelopment) {
    return process.env.CLIENT_URI ? process.env.CLIENT_URI : `http://${process.env.HOST}:${process.env.PORT}`;
  }
  return '';
};

const RESOURCE_HOST = getHost();

const backendInitOptions: HttpApi['options'] = {
  // `allowMultiLoading` is false and so `languages` and `namespaces` arguments are arrays of length 1.
  loadPath: ([language], [namespace]) => {
    if (__STORYBOOK__) {
      return `locales/${language}/${namespace}.json`;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const targetPath = (manifest as Record<string, any>)[language]?.[namespace];
    const fallbackPath = `/bliss-apps/joy-web/static/locales/${language}/${namespace}.json`;
    return `${RESOURCE_HOST}${targetPath || fallbackPath}`;
  },
};

if (__BROWSER__) {
  if (__VITE__) {
    const translationModules = (() => ({}));
    i18nLibrary.use({
      type: 'backend',
      init: () => {},
      read: async (language: string, namespace: string, callback: Function) => {
        const loader = translationModules[`../../../locales/${language}/${namespace}.json`];
        const module = (await loader()) as { default: Record<string, string> };
        callback(null, module.default);
      },
    });
  } else {
    // In browser, when Webpack, use http backend to load translations and browser lng detector
    i18nLibrary.use(HttpApi);
  }
  i18nLibrary
    // pass the i18n instance to react-i18next.
    .use(initReactI18next) // React post processor for inline react elements in translation
    .use(
      new ReactPostprocessor({
        prefix: '<',
        suffix: '/>',
      }),
    );

  if (!i18nLibrary.isInitialized) {
    i18nLibrary.init({
      ...getInitOptions({
        debug: false, // Too many warning messages crashes the console.
        backend: backendInitOptions,
      }),
    });
  }
}

export default i18nLibrary;
